import * as yup from 'yup';

export type ForgotPasswordData = {
  email: string;
};

export const forgotPasswordSchema = yup.object({
  email: yup
    .string()
    .email('Invalid email format')
    .required('Email is required'),
});

export const forgotPasswordDefaultValues: ForgotPasswordData = {
  email: '',
};
